module.exports = __webpack_public_path__ + "static/success-cef4f82ed222a347132953866ab35fa5.mp3";